<template>


    <div class="cookie-panel" v-show="showCookie">
        <transition name="cookie-panel-overlay-toggle">
            <div class="cookie-panel__overlay" v-show="showCookie"></div>
        </transition>
        <transition name="cookie-panel-toggle">
            <div class="cookie-panel__content" v-show="showCookie">
                <slot></slot>
                <button class="cookie-panel__button" @click="hideBanner">Close</button>
            </div>
        </transition>
    </div>
    
</template>

<script>


    export default {

        data() {
            return {
                showCookie: false,
                expiryDate: 1000*60*60*24*30, 
                timestamp: localStorage.getItem('cookie')
            }
        },

        mounted() {
            this.shouldShow();
        },

        methods: {

            shouldShow() {

                if(this.timestamp === null || parseInt(this.timestamp)+this.expiryDate < Date.now()){
                    this.showCookie = true;
                    document.body.classList.add('is-locked')
                }

            },

            hideBanner() {
                this.showCookie = false;
                document.body.classList.remove('is-locked');
                localStorage.setItem('cookie',Date.now());
            }
        }
        
    }

</script>